import React from "react";

import TableDefault from "../Table";
import FilterDefault from "../Filter";
import AdvancedFilter from "../AdvancedFilter"
import ModalDefault from "../Modal";
import FormDefault from "../Form";
import "./index.less";
export default class Crud extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  slots = [
    "CRUD-FILTER-TOP",
    "CRUD-FILTER-BOTTOM",
    "CRUD-TABLE-TOP",
    "CRUD-TABLE-BOTTOM",
    "CRUD-FORM-TOP",
    "CRUD-FORM-BOTTOM",
    "CRUD-FILTER-INLINE"
  ];

  getSlot = key => {
    return React.Children.map(this.props.children, (child, i) => {
      return child && child.key === key ? child : null;
    });
  };

  getOtherSlot = () => {
    return React.Children.map(this.props.children, (child, i) => {
      return child && this.slots.includes(child.key) ? null : child;
    });
  };

  render() {
    const {
      defaultFilterValue = {},
      defaultFormValue = {},

      listProps = {},
      filterProps = {},
      modalProps = {},
      formProps = {},

      filter,
      modal,
      form,
      list,

      FilterSchema,
      FormSchema,
      ListSchema,

      filterMode,
      filterResetCallBack,
      className,
      style,
      ...restProps
    } = this.props;
    const Table = this.props.Table || TableDefault;
    const Filter = this.props.Filter ? this.props.Filter : this.props.filterMode ? FilterDefault : AdvancedFilter;
    const Modal = this.props.Modal || ModalDefault;
    const Form = this.props.Form || FormDefault;
    return (
      <div className={["TUI-Crud", className].filter(d => !!d).join(" ")} style={style}>
        {this.getSlot("CRUD-FILTER-TOP")}
        {FilterSchema ? (
          <Filter
            schema={FilterSchema}
            defaultValue={defaultFilterValue}
            onSearch={(query) =>
              list.doFetch(
                filterMode ? filter.fields : query,
                {
                  ...list.pagination,
                  current: 1,
                },
                list.filters,
                list.sorters
              )
            }
            onReset={() =>
              filter
                .reset(defaultFilterValue)
                .then((filter) => {
                  filterResetCallBack && (typeof filterResetCallBack === "function") && filterResetCallBack();
                  list.doFetch(
                    filter,
                    {
                      ...list.pagination,
                      current: 1,
                    },
                  )
                })
            }
            onFieldChange={filter.setField}
            onChange={filter.setFields}
            fields={filter.fields}
            errors={filter.errors}
            validate={filter.validate}
			setTempValue={filter.setTempValue}
            ref={filter.ref}
            {...filterProps}
          >{this.getSlot("CRUD-FILTER-INLINE")}</Filter>
        ) : null}

        {this.getSlot("CRUD-FILTER-BOTTOM")}
        {this.getSlot("CRUD-TABLE-TOP")}
          { ListSchema?<Table
          loading={list.loading}
          data={list.data}
          columns={list.createColumn({
            form,
            modal,
            filter,
            list,
            ...restProps
          })}
          rowSelection={{
            onChange: (selectedKeys, selectedRows) => {
              list.setSelected(selectedKeys, selectedRows);
            },
            selectedRowKeys: list.selectedKeys
          }}
          pagination={{defaultPageSize: 20 ,...list.pagination}}
          onChange={list.onChange}
          {...listProps}
        />:null }
        {this.getSlot("CRUD-TABLE-BOTTOM")}

        <Modal
          visible={modal.visible}
          maskClosable={false}
          destroyOnClose={true}
          onOk={() => {
            form
              .submit()
              .then(() => {
                modal.close();
                form.reset();
                list.doFetch(
                  filter.fields,
                  list.pagination,
                  list.filters,
                  list.sorters
                )
              })
              .catch(e => {});
          }}
          onCancel={() => {
            modal.close();
            form.reset();
          }}
          confirmLoading={form.submitting}
          {...modalProps}
        >
          {this.getSlot("CRUD-FORM-TOP")}
          <Form
            schema={FormSchema}
            defaultValue={defaultFormValue}
            fields={form.fields}
            errors={form.errors}
            onFieldChange={form.setField}
            onChange={form.setFields}
            {...formProps}
          />
          {this.getSlot("CRUD-FORM-BOTTOM")}
        </Modal>

        {this.getOtherSlot()}
      </div>
    );
  }
}
